import React from "react";
import { Tooltip, IconButton } from "@material-ui/core"; 
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
    downloadCapturesIcon: {
        color: "#3474b4"
    }
});

type DownloadIconButtonProps = {
    buttonTooltipText: string,
    disabled: boolean,
    onDownload: () => void  
}

/**
 * This is a re-usable Component. Provides a download icon button with tooltip
 */
const DownloadIconButton: React.FunctionComponent<DownloadIconButtonProps> = (props: DownloadIconButtonProps) => {
    const styles = useStyles();
    return (
        <Tooltip title={props.buttonTooltipText} placement="bottom-end">
            <span>
                <IconButton disabled={props.disabled} onClick={props.onDownload}>
                    <CloudDownloadIcon      
                        className={props.disabled ? '' : styles.downloadCapturesIcon }
                    />
                </IconButton>
            </span>
        </Tooltip>
    );  
}

export default DownloadIconButton;